import { render, staticRenderFns } from "./joinPage.vue?vue&type=template&id=3d966bb8&"
import script from "./joinPage.vue?vue&type=script&lang=js&"
export * from "./joinPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports